var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { WEEKLY_BAR_STATUSES, WeeklyTargetLegend, } from '../../constants/weeklyTarget';
import { getStudentsNames } from '../../utils/students';
import { Tooltip } from '@hn-ui/tooltips';
import { useWeeklyDashboardAnalytics, WeeklyDashboardEvents, } from '../../hooks/useWeeklyDashboardAnalytics';
var Bar = styled.div.withConfig({ displayName: "Bar", componentId: "sc-1wbfz5y" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 306px;\n"], ["\n  position: relative;\n  width: 306px;\n"])));
var Scale = styled.div.withConfig({ displayName: "Scale", componentId: "sc-2ibiy5" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  gap: 2px;\n  width: 100%;\n  height: 16px;\n"], ["\n  display: flex;\n  gap: 2px;\n  width: 100%;\n  height: 16px;\n"])));
var ScaleSection = styled.figure.withConfig({ displayName: "ScaleSection", componentId: "sc-6n7yrm" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  min-width: 1%;\n  height: 100%;\n  flex-grow: 1;\n  background-repeat: no-repeat;\n\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n"], ["\n  position: relative;\n  min-width: 1%;\n  height: 100%;\n  flex-grow: 1;\n  background-repeat: no-repeat;\n\n  &:first-child {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n  }\n\n  &:last-child {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n  }\n"])));
var ScaleSectionLabel = styled.figcaption.withConfig({ displayName: "ScaleSectionLabel", componentId: "sc-qhtotj" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(0, -100%);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate(0, -100%);\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.1px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.black10;
});
var WeeklyProgressBar = function (_a) {
    var metric = _a.metric, results = _a.results, students = _a.students, total = _a.total, props = __rest(_a, ["metric", "results", "students", "total"]);
    var sendGaEvent = useWeeklyDashboardAnalytics();
    return (_jsx(Bar, __assign({}, props, { role: 'progressbar' }, { children: _jsx(Scale, { children: WEEKLY_BAR_STATUSES.map(function (status) {
                var studentsIds = results[status];
                var studentsCount = studentsIds.length;
                var names = getStudentsNames(studentsIds, students);
                if (studentsCount === 0)
                    return null;
                var rate = Math.round((studentsCount / total) * 100);
                var event = Events[metric][status];
                return (_jsx(Tooltip, __assign({ content: names, maxWidth: 'none', placement: 'top' }, { children: _jsx(ScaleSection, __assign({ style: {
                            background: WeeklyTargetLegend[status].color,
                            width: rate + "%",
                        }, tabIndex: 0, onMouseEnter: function () {
                            sendGaEvent(event);
                        } }, { children: _jsx(ScaleSectionLabel, { children: _jsx("span", { children: studentsCount }, void 0) }, void 0) }), void 0) }), status));
            }) }, void 0) }), void 0));
};
var Events = {
    task: {
        completed: WeeklyDashboardEvents.taskBarHoverCompleted,
        over_halfway: WeeklyDashboardEvents.taskBarHoverHalfway,
        started: WeeklyDashboardEvents.taskBarHoverStarted,
        not_started: WeeklyDashboardEvents.taskBarHoverNotStarted,
    },
    time: {
        completed: WeeklyDashboardEvents.timeBarHoverCompleted,
        over_halfway: WeeklyDashboardEvents.timeBarHoverHalfway,
        started: WeeklyDashboardEvents.timeBarHoverStarted,
        not_started: WeeklyDashboardEvents.timeBarHoverNotStarted,
    },
};
export { WeeklyProgressBar };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
